import { BenchmarkingReportSettings } from '@/hooks'
import { EntityDetail } from './getEntityDetails'
import { formatDateForTable } from '@/utils/formatDateForTable'

export const normalizeTableData = (
    processedData: Record<string, unknown>[],
    entitiesMap: Map<string, EntityDetail>,
    displaySettings: BenchmarkingReportSettings
) => {
    let result: Record<string, unknown>[] = []

    if (displaySettings.analysisType === 'trend') {
        result = normalizeTrendTableData(processedData)
    } else {
        result = processedData
    }

    return result.sort((a, b) => {
        const aName =
            entitiesMap.get(a.entityId as string)?.name ||
            (a.entityId as string)
        const bName =
            entitiesMap.get(b.entityId as string)?.name ||
            (b.entityId as string)

        return aName.localeCompare(bName)
    })
}

const normalizeTrendTableData = (processedData: Record<string, unknown>[]) => {
    const entityMap = new Map<string, Record<string, unknown>>()

    for (const item of processedData) {
        if (!('date' in item)) {
            continue
        }

        const keys = Object.keys(item).filter((key) => key !== 'date')
        const date = formatDateForTable(item.date as string)

        for (const key of keys) {
            const existingEntry = entityMap.get(key)

            if (!existingEntry) {
                entityMap.set(key, {
                    entityId: key,
                    [date]: item[key],
                })
                continue
            }

            existingEntry[date] = item[key]
        }
    }

    return Array.from(entityMap.values())
}
